<div class="common-tabs mt-4">
  <div class="row">
    <div class="col-md-12">
      <div class="tabs-group">
        <div class="tab-header" [ngClass]="{ active: isQuotationTab }">
          <div class="title-container">
            <div class="tab-badge tab-badge-icon">
              <i class="fa fa-plane" aria-hidden="true"></i>
            </div>
            <span class="title">{{ 'quote' | translate }}</span>
          </div>
        </div>
        <div class="tab-header" [ngClass]="{ active: isCustomerInfoTab }">
          <div class="title-container">
            <div class="tab-badge tab-badge-icon">
              <i class="fa fa-address-book" aria-hidden="true"></i>
            </div>
            <span class="title">{{ 'customerInfo' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
